import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from "react-redux";

import { CssVarsProvider } from '@mui/joy/styles';
import GlobalStyles from '@mui/joy/GlobalStyles';
import CssBaseline from '@mui/joy/CssBaseline';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel, { formLabelClasses } from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import theme from '../../../utils/theme';
import { AspectRatio, Avatar, Card, CircularProgress, DialogContent, DialogTitle, Modal, ModalClose, ModalDialog } from '@mui/joy';

import { Link, useNavigate } from 'react-router-dom';

import { loginRequest, loginReset, otpRequest, otpReset } from '../../../store/actions'


import image from '../../../constant/image';
import { NAVIGATE_TO_DASHBOARD, NAVIGATE_TO_FORGETPASSWORD } from '../../../route/types';
import { toast } from 'react-toastify';
import { STATUS } from '../../../constant';
import { LoadingView } from '../../../components';

interface FormElements extends HTMLFormControlsCollection {
    email: HTMLInputElement;
    // usermail: HTMLInputElement;
    password: HTMLInputElement;
    // persistent: HTMLInputElement;
}
interface SignInFormElement extends HTMLFormElement {
    readonly elements: FormElements;
}

const LoginPage = ({
    loginStatus,
    loginResult,
    loginErrorMessage,

    otpStatus,
    otpResult,
    otpErrorMessage
}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const [OTPModal, setOTPModal] = useState(false);
    const [loadOTP, setLoadOTP] = useState(false);
    const [OTP, setOTP] = useState('')
    const [username, setUsername] = useState('')

    useEffect(() => {
        if (loginStatus === STATUS.SUCCESS) {
            // navigate(NAVIGATE_TO_DASHBOARD, { replace: true })
            setOTPModal(true);
            dispatch(loginReset());
        }
        else if (loginStatus === STATUS.ERROR) {
            toast.error(loginErrorMessage)
            dispatch(loginReset())
        }

        if (otpStatus === STATUS.SUCCESS){
            navigate(NAVIGATE_TO_DASHBOARD, { replace: true })
            setLoadOTP(false);
            setOTPModal(false);
        } 
        else if (otpStatus === STATUS.ERROR){
            toast.error(otpErrorMessage)
            setLoadOTP(false);
            dispatch(otpReset())
        }
    })

    // FUNCTION TO VERIFY OTP FROM  BACKEND
    const verifyOTP = (event) => {
        event.preventDefault();
        if (OTP) {
            setLoadOTP(true)
            dispatch(otpRequest(username, OTP))

        } else {
            toast.error('Please enter OTP to verify')
        }

    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const formElements = event.currentTarget.elements;
        const data = {
            email: formElements.email.value,
            password: formElements.password.value,
        };
        console.log(data)
        if (data.email != "" && data.password != "") {
            // navigate(NAVIGATE_TO_DASHBOARD)
            dispatch(loginRequest(data.email, data.password))
            setUsername(data.email)

        } else {
            toast.error("Please fill out all fields");
        }
    }

    const checkLoading = () => {
        if (loginStatus === STATUS.LOADING) {
            return true
        } else {
            return false
        }
    }
    return (
        <CssVarsProvider defaultMode="light" disableTransitionOnChange theme={theme}>
            <CssBaseline />
            <GlobalStyles
                styles={{
                    ':root': {
                        '--Collapsed-breakpoint': '769px', // form will stretch when viewport is below `769px`
                        '--Cover-width': '50vw', // must be `vw` only
                        '--Form-maxWidth': '600px',
                        '--Transition-duration': '0.4s', // set to `none` to disable transition
                    },
                }}
            />

            {/* loading  */}
            <LoadingView loading={checkLoading()} />

            <Box
                sx={(theme) => ({
                    //   width: '90%',
                    transition: 'width var(--Transition-duration)',
                    transitionDelay: 'calc(var(--Transition-duration) + 0.1s)',
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage:
                        `url(${image.Images.backgroung})`,
                    [theme.getColorSchemeSelector('dark')]: {
                        backgroundImage:
                            `url(${image.Images.backgroung2})`,
                    },
                })}
            >

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '100dvh',
                        // width:
                        //   'clamp(var(--Form-maxWidth), (var(--Collapsed-breakpoint) - 100vw) * 999, 100%)',
                        maxWidth: '100%',
                        px: 2,
                    }}
                >
                    <Box
                        component="header"
                        sx={{
                            py: 4,
                            gap: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            alignSelf: 'center'
                            // justifyContent: 'center',
                            // flexDirection: 'column',
                        }}
                    >
                        <Avatar
                            src={image.Images.logo}
                            size='sm'
                            sx={{
                                width: 180, height: 180, borderRadius: 10, backgroundColor: 'transparent',
                            }}
                        />
                    </Box>
                    <Card
                        component="main"
                        sx={{
                            my: 'auto',
                            py: 2,
                            pb: 5,
                            p: 3,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            width: 400,
                            maxWidth: '100%',
                            mx: 'auto',

                            backgroundColor: 'background.body',
                            borderRadius: 'sm',
                            '& form': {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                            },
                            [`& .${formLabelClasses.asterisk}`]: {
                                visibility: 'hidden',
                            },
                        }}
                    >
                        <Stack gap={4} sx={{ mb: 2 }}>
                            <Stack gap={1}>
                                <Typography level="h3">Sign in</Typography>

                            </Stack>
                        </Stack>
                        <Divider
                            sx={(theme) => ({
                                [theme.getColorSchemeSelector('light')]: {
                                    color: { xs: '#FFF', md: 'text.tertiary' },
                                    '--Divider-lineColor': {
                                        xs: '#FFF',
                                        md: 'var(--joy-palette-divider)',
                                    },
                                },
                            })}
                        />


                        <Stack component='form' onSubmit={handleSubmit} gap={4} sx={{ mt: 2 }} noValidate>
                            <FormControl required>
                                <FormLabel>Username</FormLabel>
                                <Input type="text" name="email" placeholder='Enter username' />
                            </FormControl>
                            <FormControl required>
                                <FormLabel>Password</FormLabel>
                                <Input type="password" name="password" placeholder='*********' />
                            </FormControl>
                            <Stack gap={1} sx={{ mt: 2 }}>
                                <Link to={NAVIGATE_TO_FORGETPASSWORD} style={{ textDecoration: 'none' }}>
                                    <Typography level='body-sm' sx={{ color: 'blue' }}>Forget Password ?</Typography>
                                </Link>
                                <Button type="submit" fullWidth>
                                    Sign in
                                </Button>
                            </Stack>
                        </Stack>
                    </Card>
                    <Box component="footer" sx={{ py: 3 }}>
                        <Typography level="body-xs" textAlign="center" sx={{ color: 'whitesmoke' }}>
                            © Sava Tanzania {new Date().getFullYear()}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* OTP MODAL */}
            <Modal open={OTPModal} >
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {  // ----------------> FOR MOBILE
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            // borderRadius: 0,
                            borderTopLeftRadius: 20,
                            borderTopRightRadius: 20,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                    })}>
                    <ModalClose variant="outlined" component="button" onClick={() => setOTPModal(false)} />
                    <DialogTitle>OTP Verification</DialogTitle>
                    <DialogContent>Please enter OTP that has been sent to your email.</DialogContent>
                    <form
                        onSubmit={verifyOTP}
                    >
                        <FormControl sx={{ pb: 1 }}>
                            {/* <FormLabel></FormLabel> */}
                            <Input
                                autoFocus
                                type="password"
                                required
                                value={OTP}
                                placeholder='Insert OTP here'
                                onChange={(event) => setOTP(event.target.value)}
                            />
                        </FormControl>

                        <Button
                            startDecorator={loadOTP && <CircularProgress />}
                            type="submit"
                            fullWidth>
                            {loadOTP ? "LOADING..." : "CONFIRM"}
                        </Button>
                    </form>
                </ModalDialog>
            </Modal>

        </CssVarsProvider>
    );
}

const mapStateToProps = ({ auth }) => {
    const {
        loginStatus: loginStatus,
        loginResult: loginResult,
        loginErrorMessage: loginErrorMessage,

        otpStatus: otpStatus,
        otpResult: otpResult,
        otpErrorMessage: otpErrorMessage
    } = auth

    return {
        loginStatus,
        loginResult,
        loginErrorMessage,

        otpStatus,
        otpResult,
        otpErrorMessage
    }
}

// export default LoginPage
export default connect(mapStateToProps, {})(LoginPage)